import { PHONE_NUMBER } from '@/constants/Common'
import { LocalePerformance } from '../en/performance'

const performance: LocalePerformance = {
  myPerformance: '我的表現',
  wins: '獲勝',
  losses: '失敗',
  avgPoints: '平均分數',
  avgPts: '平均分數',
  avgPartner: '搭檔平均級別',
  avgPtr: '搭檔平均級別',
  avgOpponent: '對手平均級別',
  win: '勝利',
  loss: '失敗',
  reject: '不合格',
  validate: '驗證',
  validateMatch: '驗證比賽',
  confirmValidateMatch: '您確定要驗證這些分數嗎？ 如果是這樣，比賽結束並且選手等級將會更新',
  matchSourceLeague: `如果這些分數不正確，請聯系賽事負責人或發短信 ${PHONE_NUMBER} 告知正確的分數。`,
  deleteMatchConfirm: '如果您刪除此匹配項，您將必須重新開始輸入分數並使其影響您的評分',
  halfLife: '半衰期',
  avgOpp: '平均上升',
  matchesEmpty: '您還沒有參加任何比賽！',
  matchesEmptyDes: '找一些一起玩的球员開始你的旅程！',
}

export default performance
